import React from "react";
import logger from "logger";
import axios from "axios";
import Constants from "Utils/Constants";
import { getTroopNameFromId } from "Utils/Common";
import Header from "Common/Header";
import AccountDetailToolbar from "./Toolbar";
import Grid from "@material-ui/core/Grid";
import HeroStatsCard from "./HeroStatsCard";
import ServicesCard from "./ServicesCard";
import AccountStatsCard from "./AccountStatsCard";
import { useSelector } from "react-redux";
import * as TaskService from "Utils/TaskService";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions";
import store from "store";
import { getWrappedJSON } from "Utils/Common";
import Tasklet from "TaskHistory/Tasklet";
import TaskletCard from "TaskHistory/Tasklet/Tasklets/TaskletCard";
import CardContent from "@material-ui/core/CardContent";

export const loadData = (user, server, account, history) => {
  const accountdetailrow = {
    account,
    server,
  };
  store.dispatch({ type: "SETACCOUNTDETAILROW", payload: accountdetailrow });
  var dataparams = getWrappedJSON({
    ...accountdetailrow,
    forceload: false,
  });
  store.dispatch({ type: "ISLOADING", payload: true });
  return axios
    .post(Constants.getaccountdetailsApiPath, dataparams)
    .then(({ data }) => {
      logger.log("load data", data);
      store.dispatch({ type: "SETACCOUNTDETAIL", payload: data.data });
    })
    .then(() => {
      history &&
        history.push({
          pathname: Constants.accountdetail,
        });
      store.dispatch({ type: "ISLOADING", payload: false });
    })
    .catch((err) => {
      console.error(err);
      store.dispatch({ type: "ISLOADING", payload: false });
    });
};

export const AccountDetail = (props) => {
  const accountdetail = useSelector(({ rootScope }) => rootScope.accountdetail);
  const accountdetailrow = useSelector(
    ({ rootScope }) => rootScope.accountdetailrow
  );
  const user = useSelector(({ rootScope }) => rootScope.user);

  logger.log("accountdetail", accountdetail, accountdetailrow);

  const { protocol, hostname, port } = window.location;
  let wallremoverurl = null;
  if (accountdetail.wallremoverconfig) {
    wallremoverurl = `${protocol}//${hostname}${
      port ? ":" + port : ""
    }/#/ui/wallremover?passcode=${accountdetail.wallremoverconfig.passcode}`;
  }

  const { tasks } = accountdetail;

  logger.log("tasks", tasks);

  return (
    <div>
      <Header />
      <br />
      <AccountDetailToolbar
        accountdetailrow={accountdetailrow}
        AccountDetailData={accountdetail}
        loadData={() =>
          loadData(user, accountdetailrow.server, accountdetailrow.account)
        }
      />
      <div className="komform">
        <Grid container spacing={1}>
          <Grid item>
            <AccountStatsCard accountdetail={accountdetail} />
          </Grid>
          <Grid item>
            <HeroStatsCard accountdetail={accountdetail} />
          </Grid>
          <Grid item>
            <ServicesCard
              accountdetail={accountdetail}
              accountdetailrow={accountdetailrow}
            />
          </Grid>
          {tasks &&
            tasks.map((task) => {
              return (
                <Grid item>
                  <Tasklet task={task} />
                </Grid>
              );
            })}
          {accountdetail.wallremoverconfig && (
            <Grid item>
              <div>
                <TaskletCard title="Wall Remover Service">
                  <CardContent>
                    <div className="infokey">Passcode</div>
                    <div className="infovalue">
                      {accountdetail.wallremoverconfig.passcode}
                    </div>
                    <div className="infokey">Hitter Hero</div>
                    <div className="infovalue">
                      {accountdetail.wallremoverconfig.selectedhero.heroname}
                    </div>
                    <div className="infokey">Troops</div>
                    {Object.keys(accountdetail.wallremoverconfig.troops).map(
                      (key) => {
                        const value =
                          accountdetail.wallremoverconfig.troops[key];
                        return (
                          <div
                            className="infovalue"
                            style={{ fontSize: "15px" }}
                          >
                            {getTroopNameFromId(key)} :{value}
                          </div>
                        );
                      }
                    )}
                    <div className="infokey">Status</div>
                    <div className="infovalue">Running</div>
                    <div className="infokey">
                      Share link with people for using this remover:
                    </div>
                    <div className="infovalue">
                      <a href={wallremoverurl}>{wallremoverurl}</a>
                    </div>
                  </CardContent>
                  <CardActions
                    layout="row"
                    layout-align="end center"
                    style={{ "vertical-align": "bottom" }}
                  >
                    <Button
                      className="toolbarbutton"
                      onClick={() => {
                        TaskService.removeAccountFromWallRemover(
                          accountdetailrow
                        );
                      }}
                      style={{
                        font: "15px arial, sans-serif",
                        border: "thin",
                        backgroundColor: "red",
                        width: "auto",
                      }}
                    >
                      Stop
                    </Button>
                  </CardActions>
                </TaskletCard>
              </div>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};
